import { fragments } from '@/gql'
import gql from 'graphql-tag'
const q = gql`
    query AllPrizes {
      AllPrizes: Awards(limit: 500, valueKey: "parentID", value: null, op: "is") {
        ...awardDetail
        AwardToAwardPrizes {
          ...awardPrizeDetail
        }
      }
    }
    ${fragments.awardDetail}
    ${fragments.awardPrizeDetail}
  `
export default q
